/* ============================================================
   QOIO — Carosello "Nuovo Colore" (qoio-carousel.js)
   Vanilla, ~2KB. Crossfade + autoplay pausabile + swipe.
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.qclInit) return;
    root.dataset.qclInit = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.qcl-car__slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.qcl-car__dot'));
    if (slides.length < 2) return;

    var INTERVAL = parseInt(root.getAttribute('data-interval'), 10) || 6500;
    var TICK = 50;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.getAttribute('data-autoplay') !== 'false' && !reduced;
    var i = 0, elapsed = 0, paused = false, animating = false;

    function goTo(n) {
      if (animating) return;
      n = (n + slides.length) % slides.length;
      if (n === i) return;
      animating = true;
      slides[i].classList.remove('is-active');
      slides[n].classList.add('is-active');
      if (dots[i]) { dots[i].setAttribute('aria-current', 'false'); dots[i].style.setProperty('--p', 0); }
      if (dots[n]) dots[n].setAttribute('aria-current', 'true');
      i = n; elapsed = 0;
      window.setTimeout(function () { animating = false; }, reduced ? 0 : 870);
    }

    Array.prototype.forEach.call(root.querySelectorAll('.qcl-car__btn'), function (b) {
      b.addEventListener('click', function () { goTo(i + parseInt(b.getAttribute('data-dir'), 10)); });
    });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { goTo(n); }); });

    if (autoplay) {
      window.setInterval(function () {
        if (paused || document.hidden) return;
        elapsed += TICK;
        if (dots[i]) dots[i].style.setProperty('--p', Math.min(elapsed / INTERVAL, 1));
        if (elapsed >= INTERVAL) goTo(i + 1);
      }, TICK);
    }

    function pause() { paused = true; }
    function resume() { paused = false; }
    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', resume);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { resume(); } else { pause(); }
      }, { threshold: 0.25 }).observe(root);
    }

    var startX = null;
    root.addEventListener('pointerdown', function (e) { startX = e.clientX; pause(); }, { passive: true });
    root.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX; startX = null;
      if (Math.abs(dx) > 40) goTo(i + (dx < 0 ? 1 : -1));
      window.setTimeout(resume, 400);
    }, { passive: true });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') goTo(i - 1);
      if (e.key === 'ArrowRight') goTo(i + 1);
    });

    /* Editor tema: selezione blocco slide */
    document.addEventListener('shopify:block:select', function (e) {
      if (!root.contains(e.target)) return;
      var idx = slides.indexOf(e.target);
      if (idx > -1) { pause(); animating = false; goTo(idx); }
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      if (root.contains(e.target)) resume();
    });
  }

  function initAll(ctx) {
    Array.prototype.forEach.call((ctx || document).querySelectorAll('[data-qcl-car]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
